import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'todolist/index',
    pathMatch: 'full',
  },
  {
    path: 'todolist/index',
    loadChildren: () =>
      import('../app/screens/todo-list/todo-list.module').then(
        (s) => s.TodoListModule
      ),
  },
  {
    path: 'carteraproyectos/index',
    loadChildren: () =>
      import('../app/screens/cartera-proyectos/cartera-proyectos.module').then(
        (s) => s.CarteraProyectosModule
      ),
  },
  {
    path: 'reportesuperusuario/index',
    loadChildren: () =>
      import(
        '../app/screens/reporte-super-usuario/reporte-super-usuario.module'
      ).then((s) => s.ReporteSuperUsuarioModule),
  },
  {
    path: 'mantenimiento/index',
    loadChildren: () =>
      import('../app/screens/mantenimiento/mantenimiento.module').then(
        (s) => s.MantenimientoModule
      ),
  },
  {
    path: 'mantenimientoproyecto/index',
    loadChildren: () =>
      import(
        '../app/screens/mantenimiento-proyecto/mantenimiento-proyecto.module'
      ).then((s) => s.MantenimientoProyectoModule),
  },
  //{
  //  path: "crearproyecto/index",
  //  loadChildren: () => import('../app/screens/crear-proyecto/crear-proyecto.module')
  //    .then(s => s.CrearProyectoModule)
  //},
  {
    path: 'crearproyecto/index',
    loadChildren: () =>
      import('../app/screens/crear-proyecto/crear-proyecto.module').then(
        (s) => s.CrearProyectoModule
      ),
  },
  {
    path: 'sponsor/index',
    loadChildren: () =>
      import('../app/screens/main-sponsor/main-sponsor.module').then(
        (s) => s.MainSponsorModule
      ),
  },
  {
    path: '**',
    pathMatch: 'full',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
